import { z } from 'zod';
export const healthResponseSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    checks: z.object({
        database: z.enum(['ok', 'fail']),
    }),
});
//# sourceMappingURL=health.js.map